import { Container, type ContainerProps } from '@mui/material'
import React, { useMemo } from 'react'

import { mergeSx } from 'utils/mui-components/merge-sx'

/**
 * This component is intended to wrap pages using MUI components to give them the desired margin, padding, and responsive
 * breakpoints. It currently has 1 breakpoint for extra large screens (xl) and 1 for all other screens.  Breakpoints are
 * calculated using the default values from the MUI theme.
 * Reference: (https://v5.mui.com/material-ui/customization/breakpoints/#default-breakpoints)
 *
 * xs: 0px
 * sm: 600px
 * md: 900px
 * lg: 1200px
 * xl: 1536px
 */
const PageContainer: React.FC<Omit<ContainerProps, 'children'>> = ({
  children,
  sx,
  ...rest
}) => {
  const sxProps = useMemo(
    () =>
      mergeSx(
        (muiTheme) => ({
          margin: 1,
          [muiTheme.breakpoints.only('xl')]: {
            px: 4,
            py: 3
          },
          [muiTheme.breakpoints.down('xl')]: {
            px: 3,
            py: 2
          }
        }),
        sx
      ),
    [sx]
  )

  return (
    <Container maxWidth="lg" sx={sxProps} {...rest}>
      {children}
    </Container>
  )
}

PageContainer.displayName = 'PageContainer'

export default PageContainer
